const AUTH_WHITELIST_PATHS = [
  '/api/auth/login',
  '/api/auth/verify',
  '/api/auth/forgot-password',
  '/api/auth/request-otp',
];

let isHandlingUnauthorized = false;
let fetchGuardInstalled = false;
let originalFetch = null;

const getRequestUrl = (requestUrl) => {
  if (!requestUrl) return '';
  if (typeof requestUrl === 'string') return requestUrl;
  if (typeof requestUrl?.url === 'string') return requestUrl.url;
  return '';
};

const isWhitelistedAuthPath = (requestUrl = '') => {
  return AUTH_WHITELIST_PATHS.some((path) => requestUrl.includes(path));
};

export const clearAuthSession = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  localStorage.removeItem('userType');
};

export const handleUnauthorizedSession = ({ requestUrl } = {}) => {
  const normalizedUrl = getRequestUrl(requestUrl);

  if (isHandlingUnauthorized || isWhitelistedAuthPath(normalizedUrl)) {
    return;
  }

  isHandlingUnauthorized = true;
  clearAuthSession();

  window.dispatchEvent(
    new CustomEvent('auth:expired', {
      detail: { requestUrl: normalizedUrl },
    })
  );

  if (window.location.pathname !== '/login') {
    window.location.assign('/login?reason=session_expired');
  }

  setTimeout(() => {
    isHandlingUnauthorized = false;
  }, 1000);
};

export const installFetchUnauthorizedGuard = () => {
  if (fetchGuardInstalled || typeof window === 'undefined' || typeof window.fetch !== 'function') {
    return () => {};
  }

  originalFetch = window.fetch.bind(window);

  window.fetch = async (input, init) => {
    const response = await originalFetch(input, init);
    const requestUrl = typeof input === 'string' ? input : input?.url;

    if (response.status === 401) {
      handleUnauthorizedSession({ requestUrl });
    }

    return response;
  };

  fetchGuardInstalled = true;

  return () => {
    if (!fetchGuardInstalled || !originalFetch) {
      return;
    }

    window.fetch = originalFetch;
    originalFetch = null;
    fetchGuardInstalled = false;
  };
};
